import React from 'react';
import NewBadge from '@wix/da-ds/pkg/Badges/NewBadge';
import s from './StandardMenuItemLabel.scss';
var StandardMenuItemLabel = function (_a) {
    var _b = _a.item, label = _b.label, complexLabel = _b.complexLabel, newTag = _b.newTag;
    // allows some items to separate visually their text label from option label
    if (complexLabel) {
        return React.createElement(React.Fragment, null, complexLabel);
    }
    return typeof label === 'string' ? (React.createElement("span", { className: s['menu-item-text-label'] },
        label,
        newTag ? React.createElement(NewBadge, { className: s['menu-item-new-tag'] }) : null)) : (React.createElement(React.Fragment, null, label));
};
StandardMenuItemLabel.displayName = 'StandardMenuItemLabel';
export default StandardMenuItemLabel;
//# sourceMappingURL=StandardMenuItemLabel.js.map